import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

/**
 * Renders an absolute, top-left stack of image-overlay badges for a listing.
 * Pure render of `buildListingBadges()` output — no rules live here.
 *
 * @param {Object} props
 * @param {Array<{key: string, label: string, color: string, icon?: string}>} props.badges
 * @param {Object} [props.style] - Optional override for the wrapper position.
 */
const ListingBadgeStack = ({ badges, style }) => {
  if (!badges || badges.length === 0) return null;
  return (
    <View style={[styles.stack, style]} pointerEvents="none">
      {badges.map((b) => (
        <View
          key={b.key}
          style={[styles.badge, { backgroundColor: b.color }, b.icon && styles.badgeWithIcon]}
        >
          {b.icon && (
            <MaterialCommunityIcons name={b.icon} size={12} color="#FFFFFF" />
          )}
          <Text style={styles.text}>{b.label}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  stack: {
    position: 'absolute',
    top: 8,
    left: 8,
    gap: 4,
  },
  badge: {
    borderRadius: 8,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  },
  badgeWithIcon: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  text: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 10,
    color: '#FFFFFF',
  },
});

export default ListingBadgeStack;
